<app-preloader></app-preloader>
<div class="router-container">
  <router-outlet></router-outlet>
</div>

<ng-container *ngIf="showFooter">
  <app-footer></app-footer>
  <ngx-scrolltop></ngx-scrolltop>
  <app-modal></app-modal>
</ng-container>
